
<div class="screen-booking">
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div style="text-align:center">{{ getAllInfos.restoName }}</div>
      <div style="font-weight:100; font-size:14px">
        <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="success-container" v-loading="loading">
      <el-row :class="'black-inputs'">
        <el-col :span="18" :offset="3">
          <br>
          <div>Votre réservation a été soumise au restaurateur.</div>
          <br>
          <div v-if="type === 'caution'">
            Une fois votre réservation validée un email de confirmation vous sera envoyé.<br>
            ATTENTION : si vous n'honorez pas votre réservation, la somme de {{ value }}€ sera débité de votre compte.
          </div>
          <div v-else>
            Une fois votre réservation validée par le restaurateur, vous recevrez un email de confirmation et un
            paiement de {{ value }}€ sera débitée de votre compte.<br>
            <br>
            Ce montant sera déduit de votre addition et n’est pas remboursable en cas d’annulation de votre part.<br>
          </div>
          <br>
          <div>
            IMPORTANT: si vous ne recevez pas d'email au bout de 48h, merci de vérifier vos spams, l'onglet Promotions
            sur Gmail ou de contacter le restaurant.<br>
          </div>
          <br>
          <div>Merci pour votre réservation. </div>
          <br>
          <div></div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
